"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileUploadAreaScreen = FileUploadAreaScreen;
var _button = require("@design/ui/button");
var _kbd = require("@design/ui/kbd");
var _fileUploadArea = require("./file-upload-area.wiring");
var _jsxRuntime = require("react/jsx-runtime");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function FileUploadAreaScreen() {
  var _w$fileUploadAreaTitl, _w$fileUploadAreaText, _w$fileUploadAreaShow, _w$buttonShowIconStar, _w$buttonLabel, _w$buttonShowKbd, _w$kbdShowLeftIcon, _w$kbdLabel, _w$kbdShowRightIcon, _w$buttonShowIconEnd;
  var w = (0, _fileUploadArea.useWiring)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      alignItems: "center",
      padding: "24px 24px 24px 24px",
      alignSelf: "stretch",
      backgroundColor: "rgba(250, 249, 247, 1)",
      border: "1px dashed rgba(162, 173, 225, 1)",
      borderRadius: "8px"
    },
    "data-sentry-component": "FileUploadAreaScreen",
    "data-sentry-source-file": "file-upload-area.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: "data:image/svg+xml,%3Csvg%20width%3D%2240%22%20height%3D%2240%22%20viewBox%3D%220%200%2040%2040%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M20%200.5C30.7696%200.5%2039.5%209.23045%2039.5%2020C39.5%2030.7696%2030.7696%2039.5%2020%2039.5C9.23045%2039.5%200.5%2030.7696%200.5%2020C0.5%209.23045%209.23045%200.5%2020%200.5Z%22%20stroke%3D%22%23F6F5F0%22%20stroke-opacity%3D%220.8%22%2F%3E%0A%3Cmask%20id%3D%22mask0_0_75%22%20style%3D%22mask-type%3Aalpha%22%20maskUnits%3D%22userSpaceOnUse%22%20x%3D%2211%22%20y%3D%2211%22%20width%3D%2218%22%20height%3D%2218%22%3E%0A%3Crect%20x%3D%2211%22%20y%3D%2211%22%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22%231C1917%22%2F%3E%0A%3C%2Fmask%3E%0A%3Cg%20mask%3D%22url(%23mask0_0_75)%22%3E%0A%3Cpath%20d%3D%22M15.4567%2025.625C15.1626%2025.625%2014.9088%2025.5183%2014.6953%2025.3048C14.4818%2025.0913%2014.375%2024.8374%2014.375%2024.5433V22.6192C14.375%2022.4984%2014.4161%2022.3973%2014.4982%2022.3158C14.5802%2022.2344%2014.6821%2022.1938%2014.804%2022.1938C14.9258%2022.1938%2015.0265%2022.2344%2015.1063%2022.3158C15.1861%2022.3973%2015.2261%2022.4984%2015.2261%2022.6192V24.5433C15.2261%2024.6009%2015.2501%2024.6538%2015.2981%2024.7019C15.3462%2024.7499%2015.3991%2024.7739%2015.4567%2024.7739H24.5433C24.6009%2024.7739%2024.6538%2024.7499%2024.7019%2024.7019C24.7499%2024.6538%2024.7739%2024.6009%2024.7739%2024.5433V22.6192C24.7739%2022.4984%2024.815%2022.3973%2024.8971%2022.3158C24.9792%2022.2344%2025.0812%2022.1938%2025.2029%2022.1938C25.3247%2022.1938%2025.4254%2022.2344%2025.5052%2022.3158C25.5851%2022.3973%2025.625%2022.4984%2025.625%2022.6192V24.5433C25.625%2024.8374%2025.5183%2025.0913%2025.3048%2025.3048C25.0913%2025.5183%2024.8374%2025.625%2024.5433%2025.625H15.4567ZM19.5746%2016.0235L17.8048%2017.7933C17.7236%2017.8769%2017.6255%2017.9168%2017.5104%2017.9129C17.3951%2017.9091%2017.2908%2017.8653%2017.1974%2017.7817C17.1143%2017.6923%2017.0739%2017.589%2017.0761%2017.4718C17.0783%2017.3544%2017.1211%2017.2539%2017.2048%2017.1703L19.6218%2014.7532C19.6787%2014.6963%2019.7384%2014.6541%2019.8009%2014.6266C19.8633%2014.5993%2019.9307%2014.5856%2020.0034%2014.5856C20.0761%2014.5856%2020.1426%2014.5993%2020.2027%2014.6266C20.2628%2014.6541%2020.3212%2014.6963%2020.3778%2014.753L22.8067%2017.1817C22.8903%2017.2653%2022.9334%2017.3641%2022.9359%2017.4781C22.9383%2017.592%2022.8976%2017.6932%2022.814%2017.7817C22.7206%2017.8653%2022.6163%2017.9071%2022.5009%2017.9071C22.3855%2017.9071%2022.2836%2017.8629%2022.1953%2017.7746L20.4254%2016.0235V22.511C20.4254%2022.6319%2020.3844%2022.733%2020.3024%2022.8144C20.2203%2022.8958%2020.1184%2022.9364%2019.9966%2022.9364C19.8749%2022.9364%2019.7741%2022.8958%2019.6942%2022.8144C19.6144%2022.733%2019.5746%2022.6319%2019.5746%2022.511V16.0235Z%22%20fill%3D%22%2364615C%22%2F%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E",
      alt: "Icon",
      style: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        justifyContent: "center",
        alignItems: "center",
        width: "40px",
        maxWidth: "100%",
        height: "40px",
        border: "1px solid rgba(246, 245, 240, 0.8)",
        borderRadius: "9999px"
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "stretch"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          alignSelf: "stretch",
          color: "rgba(28, 25, 23, 1)",
          fontFamily: "Inter",
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "20px",
          textAlign: "center"
        },
        children: (_w$fileUploadAreaTitl = w.fileUploadAreaTitle) !== null && _w$fileUploadAreaTitl !== void 0 ? _w$fileUploadAreaTitl : "Drop your files here, or click to browse"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          alignSelf: "stretch",
          color: "rgba(100, 97, 92, 1)",
          fontFamily: "Inter",
          fontSize: "12px",
          fontWeight: "400",
          lineHeight: "16px",
          letterSpacing: "0.12px",
          textAlign: "center"
        },
        children: (_w$fileUploadAreaText = w.fileUploadAreaText) !== null && _w$fileUploadAreaText !== void 0 ? _w$fileUploadAreaText : "SVG, PNG, JPG or GIF (max. 3MB)"
      })]
    }), ((_w$fileUploadAreaShow = w.fileUploadAreaShowButton) !== null && _w$fileUploadAreaShow !== void 0 ? _w$fileUploadAreaShow : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, _objectSpread(_objectSpread({}, w.button), {}, {
      variant: "default",
      size: "default",
      children: [((_w$buttonShowIconStar = w.buttonShowIconStart) !== null && _w$buttonShowIconStar !== void 0 ? _w$buttonShowIconStar : true) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          width: "20px",
          maxWidth: "100%",
          height: "20px"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            backgroundColor: "rgba(28, 25, 23, 1)"
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            backgroundColor: "rgba(100, 97, 92, 1)"
          }
        })]
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        style: {
          color: "rgba(255, 255, 255, 1)",
          fontFamily: "Inter",
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "20px"
        },
        children: (_w$buttonLabel = w.buttonLabel) !== null && _w$buttonLabel !== void 0 ? _w$buttonLabel : "Select image"
      }), ((_w$buttonShowKbd = w.buttonShowKbd) !== null && _w$buttonShowKbd !== void 0 ? _w$buttonShowKbd : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_kbd.Kbd, _objectSpread(_objectSpread({}, w.kbd), {}, {
        children: [((_w$kbdShowLeftIcon = w.kbdShowLeftIcon) !== null && _w$kbdShowLeftIcon !== void 0 ? _w$kbdShowLeftIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "12px",
            maxWidth: "100%",
            height: "12px"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              alignSelf: "stretch",
              flexGrow: "1",
              flexBasis: "0",
              minHeight: "0"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                backgroundColor: "rgba(100, 97, 92, 1)"
              }
            })
          })
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: "rgba(100, 97, 92, 1)",
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: "400",
            lineHeight: "16px",
            letterSpacing: "0.12px",
            textAlign: "center"
          },
          children: (_w$kbdLabel = w.kbdLabel) !== null && _w$kbdLabel !== void 0 ? _w$kbdLabel : "⌘"
        }), ((_w$kbdShowRightIcon = w.kbdShowRightIcon) !== null && _w$kbdShowRightIcon !== void 0 ? _w$kbdShowRightIcon : false) ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "12px",
            maxWidth: "100%",
            height: "12px"
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              alignSelf: "stretch",
              flexGrow: "1",
              flexBasis: "0",
              minHeight: "0"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                backgroundColor: "rgba(100, 97, 92, 1)"
              }
            })
          })
        }) : null]
      })) : null, ((_w$buttonShowIconEnd = w.buttonShowIconEnd) !== null && _w$buttonShowIconEnd !== void 0 ? _w$buttonShowIconEnd : false) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          width: "16px",
          maxWidth: "100%",
          height: "16px"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            backgroundColor: "rgba(28, 25, 23, 1)"
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            backgroundColor: "rgba(100, 97, 92, 1)"
          }
        })]
      }) : null]
    })) : null]
  });
}